export const CARBON_INVENTORY_ENDPOINTS = {
  CARBON_TARGETS: "/targets",
  CARBON_TARGET_LIST: "/targets/carbon/list",
  CARBON_BANK_SUBMISSIONS: (year, status) =>
    `carbon-inventory/bank/submissions?year=${year}&status=${status}`,
  CARBON_BANK_SUBMISSIONS_DETAILS: (id) =>
    `carbon-inventory/bank/submissions/${id}`,
  CARBON_BANK_OVERVIEW: (year, status) =>
    `carbon-inventory/bank/overview?year=${year}&status=${status}`,

  CARBON_TARGETS_DELETE: (id) => `/targets/carbon/${id}`,
  CARBON_TARGETS_DETAILS: (id) => `/targets/carbon/${id}`,
  CARBON_TARGETS_UPDATE: (id) => `/targets/carbon/${id}`,

  CREATE_SURVEY: "/carbon-inventory/create",
  GET_SURVEY: "/carbon-inventory/me/submissions",
  GET_SURVEY_BY_ID: (surveyId) => `/carbon-inventory/${surveyId}`,
  UPDATE_SURVEY: (surveyId) => `/carbon-inventory/upate/${surveyId}`,
  DELETE_SURVEY: (surveyId) => `/carbon-inventory/delete/${surveyId}`,
  CARBON_SURVEY_FILES: (companyId) =>
    `/carbon-inventory/files/upload/${companyId}`,
  CARBON_SUREY_FILES_DOWNLOAD: (fileId) =>
    `/carbon-inventory/files/download/${fileId}`,
  CARBON_SUREY_FILES_DELETE: `/carbon-inventory/files/delete`,
  CARBON_BANK_SUBMISSONS_REVIEW: `/carbon-inventory/bank/review`,
};
